export default "__VITE_ASSET__ed63d130__"